// fields/MetaDescriptionField.js
import React, { useState, useEffect } from "react";
import { Form, Input } from "antd";

const { TextArea } = Input;

const MetaDescriptionField = ({
  name = "meta_description",
  label = "Meta Description",
  maxLength = 160,
  required = true,
}) => {
  const [charCount, setCharCount] = useState(0);
  const form = Form.useFormInstance();

  useEffect(() => {
    const value = form.getFieldValue(name);
    setCharCount(value ? value.length : 0);
  }, [form, name]);

  const handleChange = (e) => {
    setCharCount(e.target.value.length);
  };

  const getCounterColor = () => {
    if (charCount > maxLength) return "#ff4d4f";
    if (charCount > maxLength * 0.9) return "#faad14";
    return "#52c41a";
  };

  return (
    <Form.Item
      name={name}
      label={
        <span>
          {label}
          <span
            style={{
              float: "right",
              color: getCounterColor(),
              fontSize: "12px",
            }}
          >
            {charCount}/{maxLength}
          </span>
        </span>
      }
      rules={[
        { required, message: `${label} is required.` },
        {
          max: maxLength,
          message: `${label} cannot exceed ${maxLength} characters.`,
        },
      ]}
    >
      <TextArea
        placeholder={`Enter ${label.toLowerCase()}`}
        onChange={handleChange}
        rows={3}
        showCount={false}
      />
    </Form.Item>
  );
};

export default MetaDescriptionField;
